module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "steps-view"
  }, [_c('Step', {
    attrs: {
      "steps": _vm.steps,
      "value": _vm.value
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('VwButton', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.nextStep($event)
      }
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('VwButton', {
    attrs: {
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.reset($event)
      }
    }
  }, [_vm._v("Reset")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-53809aed!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/stepView.vue
// module id = 242
// module chunks = 0